<template>
  <div class="row">
    <div class="col-12">
      <page-header has-return :page="pageConfig" @onReturn="$router.go(-1)" />
      <section-title
        container-class="tag-badge-main-info m-0 mb-3"
        content="Detalle de Alertas"
        icon="fas fa-file-alt"
      />
      <custom-result-not-found v-if="result.data === 0" />
      <div v-if="result.data.length !== 0">
        <custom-callout
          v-for="item in result.data"
          :key="item.$key"
          class="mt-4 mb-4"
          :has-toggle="false"
        >
          <div class="row">
            <div v-if="!item.billingNumber" class="col-6 col-md-2">
              <span class="body-2 text-gray">Número SIE:</span>
              <p class="body-1 font-weight-normal">
                {{ item.studentSieId }}
              </p>
            </div>

            <div v-if="!item.billingNumber" class="col-6 col-md-3">
              <span class="body-2 text-gray">
                Nombre Estudiante:
                <br />
              </span>
              <span class="body-1 font-weight-normal">{{ item.fullName }}</span>
            </div>

            <div v-if="item.billingNumber" class="col-6 col-md-2">
              <span class="body-2 text-gray">Número de Factura:</span>
              <p class="body-1 font-weight-normal">
                {{ item.billingNumber }}
              </p>
            </div>
            <div v-if="item.billingNumber" class="col-6 col-md-2">
              <span class="body-2 text-gray">Proveedor:</span>
              <p class="body-1 font-weight-normal">
                {{ item.companyName }}
              </p>
            </div>
            <div class="col-6 col-md-2">
              <span class="body-2 text-gray">
                Tipo Alerta:
                <br />
              </span>
              <span class="body-1 font-weight-normal">
                {{ item.alertType }}
              </span>
            </div>
            <div class="col-6 col-md-2">
              <span class="body-2 text-gray">
                Sub Tipo Alerta:
                <br />
              </span>
              <span class="body-1 font-weight-normal">{{ item.subType }}</span>
            </div>
            <div class="col-6 col-md-2">
              <span class="body-2 text-gray">
                Fecha:
                <br />
              </span>
              <span v-if="item.billingNumber" lass="body-1 font-weight-normal">
                {{ item.statusChangedDate | date }}
              </span>
            </div>
            <div class="col-6 col-md-2">
              <span class="body-2 text-gray">
                Record Seleccionado:
                <br />
              </span>
              <span class="body-1 font-weight-normal">
                {{ item.recordKey }}
              </span>
            </div>
          </div>
          <div class="row border-top pt-2 mr-2">
            <div class="col-12">
              <span class="body-2 text-gray">
                Alerta:
                <br />
              </span>
              <span class="body-1 font-weight-normal">
                {{ item.alertDescription }}
              </span>
            </div>
          </div>
          <br />
          <div v-if="item.message" class="row">
            <div class="col-6 col-md-9">
              <span class="body-2 text-gray">
                Mensaje:
              </span>
              <span class="body-1 font-weight-normal">
                <div v-html="item.message" />
              </span>
            </div>
          </div>
        </custom-callout>
        <pagination
          v-if="showPagination"
          :data="result.pagination"
          :page-size="pageSize"
          :show-text="true"
          @pagination-go-page="onChangePageHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import SectionTitle from 'SectionTitle';
import CustomCallout from 'custom-callout';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import appServices from '@/modules/app/api.js';
const DEFAULT_PAGE_SIZE = 15;

export default {
  name: 'AlertDetails',
  components: {
    SectionTitle,
    CustomCallout,
    PageHeader,
    Pagination,
    CustomResultNotFound,
  },
  data() {
    return {
      id: null,
      result: {
        data: [],
        pagination: {
          totalItemCount: 0,
          count: 0,
          pageCount: 0,
          currentPage: 1,
        },
      },
    };
  },
  computed: {
    pageConfig() {
      return {
        icon: 'fas fa-user-circle',
        title: 'Alerta',
        routes: ['Dashboard', 'Alerta'],
      };
    },
    showPagination() {
      return (
        this.result.data.length > 0 &&
        this.result.pagination.totalItemCount > DEFAULT_PAGE_SIZE
      );
    },
    pageSize() {
      return DEFAULT_PAGE_SIZE;
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    if (this.id) {
      this.callGetAlertDetails();
    }
  },
  methods: {
    async callGetAlertDetails(pageIndex = 1) {
      if (this.id) {
        const { data } = await appServices.getDashboardAlerts(
          this.id,
          pageIndex,
          DEFAULT_PAGE_SIZE
        );
        this.result = {
          data: data.data,
          pagination: {
            ...data,
          },
        };
      }
    },
    onChangePageHandler(page) {
      this.callGetAlertDetails(page);
    },
  },
};
</script>

<style scoped></style>
